import { Link } from "react-router-dom";
import { Sun, ShieldAlert } from "lucide-react";
import { Button } from "@/components/ui/button";

export function DaytimePromo() {
  return (
    <section className="bg-gold py-16 px-4" data-testid="home-daytime-section">
      <div className="max-w-6xl mx-auto grid md:grid-cols-[1.4fr_1fr] gap-8 items-center text-navy">
        <div>
          <p className="font-bold tracking-[0.25em] text-xs flex items-center gap-2"><Sun className="w-4 h-4" /> OPEN DAILY AT ADVENTURE ROCK · 9 AM – 6 PM</p>
          <h2 className="font-display font-black text-3xl sm:text-4xl mt-2">PLAY WHILE YOU:<br />WORK • RELAX • CONNECT</h2>
          <p className="mt-3 flex items-center gap-2 font-semibold"><ShieldAlert className="w-4 h-4 text-coral" /> Parent/Guardian stays on-site.</p>
          <div className="flex flex-wrap gap-3 mt-6">
            <Link to="/daytime"><Button className="rounded-full bg-navy text-white font-bold h-11 px-6" data-testid="home-daytime-view">VIEW DAYTIME PLAY</Button></Link>
            <Link to="/dashboard/daytime/book"><Button variant="outline" className="rounded-full border-navy text-navy bg-transparent font-bold h-11 px-6" data-testid="home-daytime-book">BOOK A PLAY DAY</Button></Link>
          </div>
        </div>
        <div className="bg-navy text-white rounded-3xl p-6 rotate-1 shadow-xl">
          <p className="font-display font-extrabold text-2xl text-turquoise">Little Rockers Mornings</p>
          <p className="text-white/70 text-sm mt-2">Open Rock Play · Homeschool Rock · Mommy & Me · Parent Work & Play · Private Playdates</p>
        </div>
      </div>
    </section>
  );
}
